module.exports = __webpack_public_path__ + "static/img/laptop-to-use3.91e123e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/laptop-to-use3.png
// module id = 2hXQ
// module chunks = 1